import React from 'react'
import styled from 'styled-components'

import IcClose from 'components/BigModalV2/images/ic-close.component.svg'

const SmallModalV2 = (props) => {
  const { title, description, icon, onClose, children, ...restProps } = props

  return (
    <WrapperBg onMouseDown={onClose}>
      <Wrapper {...restProps} onMouseDown={(e) => e.stopPropagation()}>
        <CloseRow>
          <span>
            {' '}
            <IcClose onClick={onClose} className='closeIcon' />{' '}
          </span>
        </CloseRow>
        <StaticContent>
          {icon}
          <Title>{title}</Title>
          {description}
        </StaticContent>

        <Content>{children}</Content>
      </Wrapper>
    </WrapperBg>
  )
}

export default SmallModalV2

const WrapperBg = styled.div`
  background-color: #25272ca3;
  position: absolute;
  inset: 0;
  z-index: 10000;
  display: flex;
  justify-content: center;
  align-items: center;
`

const Wrapper = styled.div`
  display: flex;
  padding: 24px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  width: 400px;
  height: 400px;

  box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.4);
  background: #fff;
`

const StaticContent = styled.div`
  display: flex;
  padding: 0px 16px;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  align-self: stretch;
  flex-grow: 1;
`

const CloseRow = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  align-self: stretch;

  span {
    cursor: pointer;
  }
`

const Title = styled.h2`
  align-self: stretch;
  color: #010101;
  text-align: center;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px; /* 140% */
  text-transform: uppercase;
  margin: 0;
`

const Content = styled.div`
  display: flex;
  flex: 1 0 0;
  width: 100%;
`



// WEBPACK FOOTER //
// ./src/components/SmallModalV2/index.js